module.exports = __webpack_public_path__ + "img/gris-2.ca156200.png";